import cn from "classnames";
import { useTranslation } from "react-i18next";

import DownloadIcon from "assets/icons/download.svg?react";

import { AnalyticsHeaderProps } from "./AnalyticsHeader.types";

import { Button } from "shared/ui/components/Button";
import { Select } from "shared/ui/components/Select";
import { Loader } from "shared/ui/components/Loader";
import { Typography } from "shared/ui/components/Typography";
import { ToggleButton } from "shared/ui/components/ToggleButton";

import styles from "./AnalyticsHeader.module.scss";

const AnalyticsHeader = ({
  documentDownloadLoading,
  headerRef,
  sticky,
  analyticsType,
  onAnalyticsTypeChange,
  activePosition,
  onPositionChange,
  onDownloadPDFClick,
}: AnalyticsHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.root)} ref={headerRef}>
      <div className={cn(styles.header, { [styles.fixed]: sticky })}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <Typography
              className={styles.title}
              variant="bodyM"
              weight="regular"
              component={"h1"}
            >
              {t("my_parameters.benefit")}
            </Typography>
            <Select
              className={styles.select}
              menuClassName={styles.selectMenu}
              controlClassName={styles.selectControl}
              dropdownIndicatorClassName={styles.selectDropdownIndicator}
              hideSelectedOptions={false}
              blockScrollOnMenu={false}
              options={[
                {
                  value: 10,
                  label: `10`,
                },
                {
                  value: 20,
                  label: `20`,
                },
                {
                  value: 30,
                  label: `30`,
                },
              ]}
              value={{
                value: activePosition,
                label: activePosition,
              }}
              valueRenderer={({ data }) => (
                <Typography
                  className={cn(styles.selectValue)}
                  variant="bodyM"
                  weight="regular"
                >
                  {data}
                </Typography>
              )}
              optionRenderer={({ data, innerProps, isSelected }) => {
                return (
                  <Typography
                    onClick={innerProps.onClick}
                    className={cn(styles.selectOption, {
                      [styles.selectOptionActive]: isSelected,
                    })}
                    variant="bodyS"
                    weight="semiBold"
                  >
                    {data}
                    <span />
                  </Typography>
                );
              }}
              onChange={({ value }) => onPositionChange(value)}
            />
            <Typography
              className={cn(styles.title, styles.yearsText)}
              variant="bodyM"
              weight="regular"
            >
              {t("my_parameters.parameters.years")}
            </Typography>
          </div>
          <div className={styles.headerRight}>
            <ToggleButton
              buttonClassName={cn(
                styles.toggleDetailsButton,
                styles.toggleButtonDesktop
              )}
              indicatorClassName={styles.toggleButtonIndicator}
              isActive={analyticsType === "details"}
              onClickToggle={onAnalyticsTypeChange}
              firstName={t("calculator_pro_page.analytics.general")}
              secondName={t("calculator_pro_page.analytics.details")}
            />
            <Button
              size="small"
              variant={"black"}
              className={styles.actionDownload}
              startIcon={
                documentDownloadLoading ? (
                  <Loader size={20} color="#fff" />
                ) : (
                  <DownloadIcon className={styles.actionDownloadIcon} />
                )
              }
              onClick={
                onDownloadPDFClick
              }
            >
              {t("calculator_pro_page.analytics.download_documentation")}
            </Button>
            <Button
              component={"a"}
              href={"#calculator"}
              variant="black"
              className={styles.changeCalculationButton}
            >
              {t("calculator_pro_page.analytics.change_calculation")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsHeader;
